import { useAuth } from "@/hooks/useAuth";

interface CanProps {
  permission?: string | string[];
  role?: string | string[];
  match?: 'any' | 'all';
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function Can({
  permission,
  role,
  match = 'any',
  children,
  fallback = null,
}: CanProps) {
  const { hasPermission, hasRole } = useAuth();

  const permissions = permission
    ? Array.isArray(permission)
      ? permission
      : [permission]
    : [];
  const roles = role
    ? Array.isArray(role)
      ? role
      : [role]
    : [];

  const checks = [
    ...permissions.map((p) => hasPermission(p)),
    ...roles.map((r) => hasRole(r)),
  ];

  const allowed = checks.length === 0 ? false : match === 'all' ? checks.every(Boolean) : checks.some(Boolean);

  return allowed ? <>{children}</> : <>{fallback}</>;
}
